import React, { Component } from "react";
import { observer } from "mobx-react";

import { combineEventFilters } from "@formant/core/common/combineFilters";
import { distinct } from "@formant/core/common/distinct";
import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IFilter } from "@formant/core/model/IFilter";
import { Uuid } from "@formant/core/model/Uuid";

import { deviceDetailsStore, eventStore } from "../../stores";
import { IMultiSelectOption, MultiSelect } from "../common/MultiSelect";

export interface IDeviceSelectProps {
    value: Uuid[];
    filter: IEventFilter;
    context: IFilter;
    className?: string;
    onChange: (value: Uuid[]) => void;
    deviceIds?: Uuid[];
    disableIfEmpty?: boolean;
}

@observer
export class DeviceSelect extends Component<IDeviceSelectProps> {
    private deviceIds: Uuid[] = [];
    public render() {
        const { value, filter, context, className, onChange, deviceIds } =
            this.props;
        this.deviceIds =
            eventStore.devices(
                combineEventFilters(context, {
                    ...filter,
                    deviceIds: undefined,
                }),
            ) ||
            deviceIds ||
            this.deviceIds;
        const _deviceIds = this.deviceIds;
        const options = distinct([..._deviceIds, ...value])
            .map<IMultiSelectOption<Uuid>>(deviceId => {
                const device = deviceDetailsStore.get(deviceId);
                return {
                    value: deviceId,
                    icon: "device",
                    label: (device && device.name) || undefined,
                };
            })
            .sort((a, b) => a.label?.localeCompare(b.label || "") || 0);
        if (options.length === 0 && !this.props.disableIfEmpty) {
            return false;
        }
        const disabled = value.length === 0 && options.length <= 1;
        return (
            <MultiSelect
                value={value}
                title="Device"
                options={options}
                className={className}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}
